import $ from "jquery";
import "lazysizes";
import 'aos';

window.$ = $;
window.jQuery = $;

if (typeof $.type !== "function") {
    $.type = (value) => {
        if (value == null) {
            return String(value);
        }
        return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
    };
}
import App from './js/app';
window.App = new App;

/**************
 * Css
 **************/

import "./css/app/base/bootstrap.scss";

//App
import "./css/app/base/html.scss";
import "./css/app/base/typography.scss";
import "./css/app/components/header.scss";
import "./css/app/components/footer.scss";
import "./css/app/components/nav.scss";
import "./css/app/components/blog.scss";